<template>
  <div class="m_search_filter_wrap">
    <div class="m_search_item_wrap">
      <div class="m_filter_category_box">
        <el-select id="category"
                   popper-class="category_select judge_modal"
                   :popper-append-to-body="false"
                   v-model="searchOption"
                   class="m_my_filter select">
          <el-option :value="'ina'" :label="$t('subject')"></el-option>
          <el-option :value="'hash'" :label="$t('hashtag')"></el-option>
          <el-option :value="'orni'" :label="$t('k_creator')"></el-option>
<!--          <el-option :value="'prni'" :label="$t('owner')"></el-option>-->
<!--          <el-option :value="'cuni'" :label="$t('curator')"></el-option>-->
        </el-select>
      </div>
      <div class="m_search_input">
        <el-input :placeholder="$t('st')" v-model="searchInput"
                  @input="setData('searchInput',searchInput)"
                  @keypress.enter="setFilterFunc(searchOption,searchInput)"/>
        <button class="m_search_btn" @click="setFilterFunc(searchOption,searchInput)"><span>{{$t('search')}}</span>
          <img src="@/assets/image/main/search_btn.png"></button>
      </div>
<!--      <div class="m_end_filter">-->
<!--        <button class="m_filter_btn two" @click="openModal('filter-modal')"></button>-->
<!--      </div>-->
      <div class="m_filter_sort_box">
        <el-select id="sort_select" v-model="sortOption" class="m_sort_filter select"
                   popper-class="category_select judge_modal"
                   :popper-append-to-body="false"
                   @change="sortChange(sortOption)">
          <el-option :value="'i.updated_at'" :label="$t('b_update')"></el-option>
          <el-option :value="'vote_desc'" :label="$t('voteDesc')"></el-option>
          <el-option :value="'score_desc'" :label="$t('scoreDesc')"></el-option>
<!--          <el-option :value="'priceDesc'" :label="$t('priceDesc')"></el-option>-->
<!--          <el-option :value="'priceAsc'" :label="$t('priceAsc')"></el-option>-->
        </el-select>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "EntryFilterDefaultLayout",
  mixins: [],
  components: {
  },
  inject: [],
  provide() {
    return{

    }
  },
  props: {
  },
  data() {
    return{
      searchOption: 'ina',
      sortOption: 'i.updated_at',
      searchInput: '',
    }
  },
  beforeRouterEnter() {},
  created() {
    this.setterFilterDataInData();
  },
  mounted() {

  },
  beforeDestroy() {
  },
  destroyed() {},
  computed: {
  },
  methods:{
    setterFilterDataInData() {
      let classnames = Object.keys(this.filterData);
      classnames.forEach(classname => {
        let obj = this.filterData[classname];
        let type = filterConfig[obj.key].type;
        if (this.hasOwnProperty(classname)) {
          // this[classname] =
          if (type == 'query') {
            this[classname] = obj.query;
            if (this.hasOwnProperty(classname + 'Option')) {
              this[classname + 'Option'] = obj.key;
            }
          } else if (type === 'between') {
            this[classname] = [obj.start, obj.end];
          } else if (type === 'match') {
            if (isNaN(obj.value)) {
              this[classname] = obj.value;
            } else {
              this[classname] = Number(obj.value);
            }

          } else if (type === 'terms') {
            this[classname] = obj.terms;
          }

        }
      })
    },
    sortChange(data) {
      if (data === 'priceAsc') {
        this.setFilterFunc('obt', 'i_price');
        this.setFilterFunc('obs', 'asc');
      } else if (data === 'priceDesc') {
        this.setFilterFunc('obt', 'i_price');
        this.setFilterFunc('obs', 'desc');
      } else {
        this.setFilterFunc('obt', data);
        this.setFilterFunc('obs', 'desc');
      }
    },
    setFilterFunc(key, value) {
      this.setFilter(key, value);
    },
    setData(key, value) {
      this[key] = value;
    },
    openModal(name) {
      this.$modal.show(name);
    },
  },
  watch: {

  },
}
</script>

<style scoped>

</style>